'use strict';
'use es6';

/*
* The event pool utilizes a queue under the hood
* for it's first-in-first-out functionality.
*/

Object.defineProperty(exports, "__esModule", {
  value: true
});
var create = exports.create = function create() {
  var queue = [];
  return {
    enqueue: function enqueue(event) {
      return queue.unshift(event);
    },
    dequeue: function dequeue() {
      return queue.shift();
    },
    peek: function peek() {
      return queue[0];
    }
  };
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/usage-tracker-core/static-1.104/js/eventPool/queue.js
// module id = 1237
// module chunks = 3